import "./CostSection.scss";

const CostSection = () => {
  const problems = [
    {
      title: "Student Dreams Shattered",
      description: "Deserving candidates lose opportunities due to unfair advantages",
    },
    {
      title: "Institutional Credibility Lost",
      description: "Universities and boards face public scrutiny and legal challenges",
    },
    {
      title: "Economic Impact",
      description: "Billions lost in re-examinations, legal proceedings, and damaged reputation",
    },
    {
      title: "Social Trust Erosion",
      description: "Public faith in education system continues to decline",
    }
  ];


  return (
    <section className="cost-section">
      <div className="cost-section-leftTop">
        <h4>Advanced Fraud Protection</h4>
        <p>Redefining digital trust with secure <br /> and intelligent technology.</p>
      </div>
      <div >
        <h2 className="cost-title">The Cost of Compromised Examinations</h2>

        <div className="cost-content">
          <div className="problems-list">
            {problems.map((problem, index) => (
              <div key={index} className="problem-item">
                <img
                  src="/LandingPageImages/StudentDreams.svg"
                  alt={problem.title}
                  className="problem-icon"
                />
                <div className="problem-content">
                  <h3 className="problem-title">{problem.title}</h3>
                  <p className="problem-description">{problem.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="cost-image">
            <img
              src="/LandingPageImages/TheCost-rightImg.png"
              alt="Cost Image"
              className="cost-image-item"
            />
            <img
              src="/LandingPageImages/cost-image-mobile.png"
              alt="Cost Image"
              className="cost-image-mobile"
            />
          </div>
        </div>
      </div >
    </section >
  );
};

export default CostSection;

